import React from "react";
import { PortalDetailedActivityTemplate } from "themes/administration/analytics/components";

function PortalDetailedActivity(props) {
    return <PortalDetailedActivityTemplate {...props} />;
}

export default PortalDetailedActivity;
